var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement, property, state } from "lit/decorators.js";
import { html, LitElement } from "lit";
import { marked } from "marked";
import changelogCss from "./changelog.css.js";
import sharedCss from "../../css/shared.css.js";
import alertsCss from "../../css/alerts.css.js";
import { ReleaseComponent } from "./release.js";
import './timeline.js';
import './timeline-item.js';
let ChangelogComponent = class ChangelogComponent extends LitElement {
    constructor() {
        super();
        this.apiURL = 'https://api.pb33f.io/release-notes/';
    }
    connectedCallback() {
        super.connectedCallback();
        this.fetchChangelogSummary()
            .then((summaries) => {
            this.summaries = summaries;
        })
            .catch((err) => {
            this.error = err;
        });
        this.extractHash();
    }
    extractHash() {
        this._linked = window.location.hash.substring(1);
    }
    async fetchChangelogSummary() {
        const response = await fetch(`${this.apiURL}/${this.project}`);
        if (!response.ok) {
            return Promise.reject(`HTTP Error ${response.status}`);
        }
        return response.json();
    }
    render() {
        if (this.error) {
            return html `
                <pb33f-attention-box headerText="unable to fetch changelog" type="error">
                    ${this.error}
                </pb33f-attention-box>
            `;
        }
        if (this.project && this.summaries?.length > 0) {
            // const extractMinorVersion = (version: string): number =>
            //     parseInt(version.split('.')[1])
            const extractPatchVersion = (version) => parseInt(version.split('.')[2]);
            const items = [];
            let selectedDetails = null;
            for (let i = 0; i < this.summaries?.length; i++) {
                const summary = this.summaries[i];
                let patchVersion = extractPatchVersion(summary.tag_name);
                let icon = html ``;
                let milestone = false;
                if (patchVersion == 0) {
                    milestone = true;
                    icon = html `
                        <sl-icon name="braces-asterisk" class="major-icon"></sl-icon>`;
                }
                const parsed = marked.parse(summary.body).toString();
                let latest = false;
                if (i == 0) {
                    latest = true;
                }
                const release = new ReleaseComponent();
                release.latest = latest;
                release.milestone = milestone;
                release.name = summary.name;
                release.published = summary.published_at;
                release.link = summary.html_url;
                release.author = summary.author;
                release.tarball = summary.tarball_url;
                release.authorLink = summary.author_url;
                release.authorImage = summary.author_image;
                release.body = parsed;
                let open = false;
                if (summary.name == this._linked) {
                    open = true;
                }
                if (open) {
                    selectedDetails = release;
                }
                items.push(html `
                    <pb33f-timeline-item-ch id="release_${summary.name}">
                        <span slot="icon">${icon}</span>
                        <span slot="time" class="${milestone ? `major` : null}">${summary.publish_date}</span>
                        <div slot="content" style="width: 100%">
                          ${release}
                        </div>
                    </pb33f-timeline-item-ch>`);
            }
            if (selectedDetails) {
                setTimeout(() => {
                    selectedDetails?.open();
                });
            }
            return html `
                <pb33f-timeline-ch>
                    ${items.map((item) => {
                return item;
            })}
                </pb33f-timeline-ch>
            `;
        }
        else {
            return html `
                <pb33f-timeline-ch>
                    <pb33f-timeline-item-ch>
                        <div slot="content">
                            <div class="pb33f-loader">
                                <div class="spin"></div>
                                fetching changelog for <em>${this.project}</em></div>
                        </div>
                    </pb33f-timeline-item-ch>
                </pb33f-timeline-ch>
            `;
        }
    }
};
ChangelogComponent.styles = [sharedCss, alertsCss, changelogCss];
__decorate([
    property()
], ChangelogComponent.prototype, "apiURL", void 0);
__decorate([
    property()
], ChangelogComponent.prototype, "project", void 0);
__decorate([
    state()
], ChangelogComponent.prototype, "summaries", void 0);
__decorate([
    state()
], ChangelogComponent.prototype, "error", void 0);
ChangelogComponent = __decorate([
    customElement('pb33f-changelog')
], ChangelogComponent);
export { ChangelogComponent };
